export const authChannel = new BroadcastChannel("auth-channel");